import { FACE_TO_FACE, MEET } from 'Constants/General';
import {
  ModuleList,
  LessonList,
  UserListPrivateLessons,
  UserLessonListByLessonId,
  UserListUsersByCourse,
} from './Request';

export const lessonList = async ({ moduleId }) => LessonList({ moduleId });

export const moduleList = async ({ courseId, userId }) => {
  const enrolledPrivateLessons = await UserListPrivateLessons({ userId });
  const mappedPrivateLessons = enrolledPrivateLessons.map(lesson => lesson.lessonId);
  const modulesFetch = await ModuleList({ courseId });
  const modules = modulesFetch?.filter(module => module.isDraft !== true);

  const promises = [];
  const lessonsList = [];

  modules.forEach(module => {
    promises.push(
      lessonList({ moduleId: module.id }).then(lessons => {
        const filteredLessons = lessons?.filter(
          lesson =>
            lesson.isDraft !== true && (lesson.LessonType.name === FACE_TO_FACE || lesson.LessonType.name === MEET)
        );
        lessonsList.push(
          ...filteredLessons.filter(lesson => lesson.isPrivate !== true || mappedPrivateLessons.includes(lesson.id))
        );
        return null;
      })
    );
  });

  await Promise.allSettled(promises);

  const lessonPromises = [];
  const userLessons = [];

  lessonsList.forEach(lesson => {
    lessonPromises.push(
      UserLessonListByLessonId({
        lessonId: lesson.id,
        isDraft: lesson.isDraft,
        attended: lesson.attended,
      }).then(data => {
        userLessons.push(data);
      })
    );
  });

  await Promise.allSettled(lessonPromises);

  lessonsList.forEach((lesson, index) => {
    lesson.userLessons = userLessons[index];

    let containsDraft = false;
    let attendedCount = 0;
    lesson.userLessons.forEach(userLesson => {
      if (userLesson.isDraft) {
        containsDraft = true;
      }

      if (userLesson.attended) {
        attendedCount += 1;
      }
    });

    lesson.containsDraft = containsDraft;
    lesson.attendedCount = attendedCount;
  });

  const response = await UserListUsersByCourse({ courseId });

  return {
    lessons: lessonsList,
    userCount: response.length,
  };
};

export default {
  moduleList,
};
